
function baiduStatistics (category, action = 'click') {
  // console.log(' window._hmt ==== ')
  window._hmt.push(['_trackEvent', category, action]);
}
function creatImgToStatistics (options) {
  const { from, service_code } = options
  // console.log(' window._hmt ==== ', from, service_code)
  const img = new Image()
  img.src = `https://www.maimiaotech.com/a.gif?service_code=${service_code}&from=${from}`
}
export {
  baiduStatistics,
  creatImgToStatistics
}

